import { Component, OnInit } from '@angular/core';

import { Customer } from '../../model/customer';
import { DataService } from '../data.service';


@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.css']
})
export class CustomerFormComponent implements OnInit {

  public customer: Customer;

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.customer = new Customer();
  }

  public dataChanged(event) {
      this.dataService.shareData('customer', this.customer);
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-form/customer-form.component.ts